var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-items" }, [
    _c(
      "div",
      { staticClass: "feed feed--events container--1240" },
      [
        _vm.events.length > 0 && !_vm.loading
          ? _c("h2", { staticClass: "feed__title" }, [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
            ])
          : !_vm.events.length && !_vm.loading
          ? _c("h2", { staticClass: "feed__title" }, [
              _vm._v(
                "\n      There are currently no events found with these filters, please update the filters to find more events\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { ref: "infinite", staticClass: "feed__items feed__items--events" },
          _vm._l(_vm.events, function(event) {
            return _c("Event", {
              key: event.id,
              attrs: {
                title: event.title,
                image: event.image,
                link: event.link,
                "primary-format": event.primary_format,
                time: event.time,
                day: event.day,
                month: event.month,
                location: event.location
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _vm.loading
          ? _c("Loading", { attrs: { color: _vm.loadingColor } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }